import { useState, useEffect, useCallback } from 'react';
import { SessionStatus } from '@/types';
import { checkSession, onSessionChange, getSessionStatus, redirectToLogin, logout as sessionLogout } from './session';

export function useSession() {
  const [status, setStatus] = useState<SessionStatus>(getSessionStatus);

  useEffect(() => {
    if (status.status === 'loading') {
      checkSession().then(setStatus);
    }
    return onSessionChange(setStatus);
  }, []);

  const login = useCallback(() => redirectToLogin(), []);
  const logout = useCallback(() => sessionLogout(), []);

  return { ...status, login, logout, refresh: () => checkSession().then(setStatus) };
}
